export type ScrollLoadingStatus = "" | "bottom" | "all";

export enum TypeSearch {
  KEY_WORD = "keyword",
  SOURCE = "source",
}

export type SearchType = "SEARCH" | "REPORT";

export enum TypeSearchTargetPage {
  SELECT_FROM_LIST = "pages",
  SELECT_DOMAINS = "domains",
  ALL_PAGE = "allPages",
}

export type SortItem = { key: string; order: "desc" | "asc" };

export interface HighLightTextParams {
  text: string;
  keywords?: string[];
  typeSearch?: TypeSearch;
  caseSensitive?: boolean;
}

export enum CUSTOM_STATUS {
  NO_HTML_RESPONSE = 601,
  REDIRECT_UNKNOWN_STATUS = 602,
}
